import LightspeedIcon from 'packages/@slerp/assets/integrations/lightspeed.png'
import ShipdayIcon from 'packages/@slerp/assets/integrations/shipday.png'
import CustomWebhookIcon from 'packages/@slerp/assets/integrations/custom-webhook.svg'

export enum PartnerName {
  LIGHTSPEED = 'LIGHTSPEED',
  SHIPDAY = 'SHIPDAY',
  LEAT = 'LEAT'
}

export const PARTNER_SLUGS = {
  LIGHTSPEED: 'lightspeed-pos',
  SHIPDAY: 'shipday',
  LEAT: 'leat'
} as const

const PARTNER_DISPLAY_NAMES = {
  LIGHTSPEED: 'Lightspeed',
  SHIPDAY: 'Shipday'
} as const

export const CUSTOM_WEBHOOK_SLUG = 'custom'
export const CUSTOM_WEBHOOK_CATEGORY = 'CUSTOM'
export { CustomWebhookIcon }

export const INTEGRATION_CATEGORY_LABELS: Record<string, string> = {
  POS: 'POS',
  DELIVERY: 'Delivery',
  [CUSTOM_WEBHOOK_CATEGORY]: 'Custom'
}

export type IntegrationRegistryEntry = {
  slug: string
  name: string
  description: string
  icon: string
}

// Record, not Partial<Record>: a new PartnerName must state an entry or an
// explicit null. Leat's null means direct-URL-only setup.
export const INTEGRATION_REGISTRY: Record<
  PartnerName,
  IntegrationRegistryEntry | null
> = {
  [PartnerName.LIGHTSPEED]: {
    slug: PARTNER_SLUGS.LIGHTSPEED,
    name: PARTNER_DISPLAY_NAMES.LIGHTSPEED,
    description:
      'Integrate Lightspeed with Slerp to sync point-of-sale data and ensure loyalty and customer interactions work seamlessly at checkout.',
    icon: LightspeedIcon
  },
  [PartnerName.SHIPDAY]: {
    slug: PARTNER_SLUGS.SHIPDAY,
    name: PARTNER_DISPLAY_NAMES.SHIPDAY,
    description:
      "Shipday lets you dispatch and track your own delivery drivers directly from Slerp. Before continuing, you'll need a Shipday merchant account.",
    icon: ShipdayIcon
  },
  [PartnerName.LEAT]: null
}

export const isPartner = (name: string, partner: PartnerName): boolean => {
  return name.toLowerCase() === partner.toLowerCase()
}

export const SHIPDAY_APP_URL =
  'https://dispatch.shipday.com/dashboard#integrations'
export const SHIPDAY_SIGNUP_URL =
  'https://dispatch.shipday.com/signUp/Uxz6fVxLkO'
export const SHIPDAY_HELP_URL =
  'https://support.slerp.com/knowledge/shipday-integration'

// TODO(author): swap in the real help-centre article; the support root
// avoids a 404 meanwhile.
export const LEAT_HELP_URL = 'https://support.slerp.com'
export const LEAT_APP_URL = 'https://business.leat.com'
